module.exports = __webpack_public_path__ + "media/packs/src/webfonts/fa-regular-400-5fab4ed5c3745c12c7e1e311b24424d0.woff2";